import React from "react";
import { Box, Typography } from "@mui/material";
import Breadcrumb from "../../components/common/breadcrumb/Breadcrumb";

const breadcrumb = ["Out Of Area"];

const OutOfArea = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Breadcrumb pageNameList={breadcrumb} />
      <Typography variant="subtitle2">Out Of Area</Typography>
    </Box>
  );
};

export default OutOfArea;
